import React, { useState, useMemo, useCallback, memo } from 'react';
import { useSelector } from 'react-redux';
import LoaderComponent from '../Loader';
import Icon from '../../icons';
import UserImage from '../UserImage';

//User list component
const UserListItem = ({ user, isSelected, onSelect }) => (
    <li onClick={() => onSelect(user.id)} className={isSelected ? 'active' : ''}>
        <div className={`rowFlex userGroup ${isSelected ? 'active' : ''}`}>
            <div className="userPic userPicIcon">
                <UserImage profileUrl={user.images} profileName={user.fullName} />
                {isSelected && <span className="badges profileChecked green" />}
            </div>
            <div className="userInfo">
                <span>{user.fullName}</span>
                <label className="mrNone">{user.title}</label>
            </div>
        </div>
    </li>
);

const FormDiaryOwner = ({ input, meta, label, helpText, isRequired, wrapperClass }) => {
    const { usersList = [], loading = false } = useSelector(
        state => state?.adminPanel?.usersData ?? {}
    );

    const [searchText, setSearchText] = useState('');
    const selectedUser = input.value;

    // Search owner list
    const filteredUsersList = useMemo(() => {
        const trimmed = searchText.trim().toLowerCase();
        return usersList.reduce((acc, user) => {
            const firstName = (user.firstName || '').toLowerCase();
            const lastName  = (user.lastName  || '').toLowerCase();
            const fullName  = `${firstName} ${lastName}`.trim();
            if (!trimmed || firstName.includes(trimmed) || lastName.includes(trimmed) || fullName.includes(trimmed)) {
                acc.push({ ...user, fullName });
            }
            return acc;
        }, []);
    }, [usersList, searchText]);

    const handleUserSelect = useCallback(
        (userId) => input.onChange(userId),
        [input]
    );

    const showNoData = !loading && searchText.trim() && filteredUsersList.length === 0;
    const rootClass = ['colFlex', wrapperClass, meta.touched && meta.error && 'errorMsg'].filter(Boolean).join(' ');

    return (
        <div className={rootClass}>
            <div className="changeAssignee">
                <div className="rowFlex">
                    <div className="ownerHeader alignMiddle">
                        {label && (
                            <label className="flexGrow mrNone">
                                {label}
                                {isRequired && <sup>*</sup>}
                                {helpText && (
                                    <span className="quickTooltip-bottom" data-quicktooltip={helpText}>
                                        <Icon name="info" className="icon ml greyInfoIcon" />
                                    </span>
                                )}
                            </label>
                        )}
                        <div className="wth-4">
                            <input
                                type="text"
                                placeholder="Search by Name or Job title"
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                <div className="col-3 scrollMemberList">
                    {loading && <LoaderComponent />}
                    {showNoData && <div className="noDataFound">No result found</div>}

                    {!loading && filteredUsersList.length > 0 && (
                        <ul className="wrapFlex assigneeList">
                            {filteredUsersList.map((user) => (
                                <UserListItem
                                    key={user.id}
                                    user={user}
                                    isSelected={String(selectedUser) === String(user.id)}
                                    onSelect={handleUserSelect}
                                />
                            ))}
                        </ul>
                    )}
                </div>
            </div>

            {meta.touched && meta.error && <span>{meta.error}</span>}
        </div>
    );
};

export default FormDiaryOwner;